// extracted by mini-css-extract-plugin
export default {"radio":"Radio-module__radio__E3zaY"};